import { Component, ViewChild, OnInit, Output, Input, HostListener, EventEmitter, ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';
import { Lists_nguonkinhphi, Lists_tinhchatnguonkp } from '../../../routes/menu'
import { Global, BaoCao } from '../../../shared/global';
import { ModalComponent } from 'ng2-bs3-modal/ng2-bs3-modal';
import 'jquery'
import 'bootstrap'


const swal = require('sweetalert');
@Component({
  selector: 'app-thamsobc-uynhiemchic4_02cedit',
  templateUrl: './uynhiemchic4_02cedit.component.html',
  //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./uynhiemchic4_02cedit.component.scss'],
  providers: [ListService, Repository]
})


export class uynhiemchic4_02ceditComponent implements OnInit {
  QuyetDinhPheDuyetNhaThau_Ngay: Date = null;
  HopDong_Ngay: Date = null;
  BienBanNghiemThu_Ngay: Date = null;
  doituongSelect1: any = {
    Id: null, MaDonVi: null, TenDonVi: null, DonViId: null, KTT_UserName: null
    , KTT_Password: null, CTK_UserName: null, CTK_Password: null
    , MaCapNS: null, SoTaiKhoanMoTaiKBNN: null, MaKBNN: null, dm_hs_ksc_id: null, TenVietTat: null
    , v_ma_ho_so: null, v_ma_ho_so_chi_tiet_mau: null, v_tieu_de: null
    , v_tg_ky_so_ktt: null, v_tg_ky_so_ctk: null, Phan_He_Id: null, LoaiMau: null
    , NguoiKy: null, v_tg_gui_dvc: null
    , NguoiKy_KTT: null, NguoiKy_CTK: null, v_du_lieu_toan_van: null
    , v_du_lieu_xac_thuc: null, v_chu_ky_so_ktt: null, v_chu_ky_so_ctk: null, body: null
    , Cer_ktt: null, Cer_ctk: null, hash_file: null
    , LoaiKy: null, Tich_HienChiTietCacButToan: null, Tich_TenTieuMucLaDienGiai: null
    , DoiTuong: null, Tich_HienThiTungDongChiTiet: null
    , GuiKeToanTruong: null, GuiThuTruong: null, ThongTinBoSung: null, ThamSo: null, TaiKhoan: null
  };
  msg: string;
  hienthikyso: boolean = true;
  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  inputparents: any
  indLoading: boolean = false;
  modalTitle: any;
  doituongSelect: any = {
    Id: null, SoCKCHDK: null, SoCKCHDTH: null, PhatHanhSec: null, ThongTinBoSung: null
    , NoTK1: null, CoTK1: null, NoTK2: null, CoTK2: null, NoTK3: null, CoTK3: null
    , MaDBHC: null, DonViId: null, NoiDungThanhToan: null
    , Tich_PhatHanhSec: null, Tich_ThongTinBoSung: null, SoToKhai: null
    , TenDonVi: null, MaSoThue: null, MaNDKT: null, MaChuong: null
    , CoQuanQuanLyThu: null, MaCQThu: null, KyThue: null, KBNNHachToanKhoanThu: null
    , ThanhToans: []
    , NoTK4: null, CoTK4: null, NoTK5: null, CoTK5: null, NoTK6: null, CoTK6: null
    , MaDBHC2: null, MaCQThu2: null, Tich_HienChiTietCacButToan: null
    , KBNNHachToanKhoanThu_Ma: null


    , QuyetDinhPheDuyetNhaThau_So: null, QuyetDinhPheDuyetNhaThau_Ngay: null
    , HopDong_So: null, HopDong_Ngay: null, HopDong_TongSoTien: null
    , QuyDinhVeMucTamUng: null, BienBanNghiemThu_So: null, BienBanNghiemThu_Ngay: null
    , BienBanNghiemThu_TongSoTien: null, MaNhaTaiTro: null

  };
  nhomdtid: string = null;
  hoatdong: string = null;
  tabselected: number = 1;
  sobanghi: number;


  //@ViewChild('modal_dvckbnn', { static: false }) modal_dvckbnn: ModalComponent;
  //@ViewChild('dtthamdvckbnnedit', { static: false }) dtthamdvckbnnedit: any;
  @ViewChild('slCapTren', { static: false }) slCapTren: NgSelectComponent;
  @ViewChild('modaltuychinhmaubc', { static: false }) modaltuychinhmaubc: ModalComponent;
  @ViewChild('dtsuamaubaocao', { static: false }) dtsuamaubaocao: any;
  @Output() save: EventEmitter<any> = new EventEmitter();



  constructor(private _dataService: ListService, private repo: Repository) {


  }

  ngOnInit(): void {

  }
  public ngxAmOptions = {
    prefix: '',
    thousands: '.',
    decimal: ',',
    precision: 0,
    allowNegative: true
  };
  comboSearchFn(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
  }
  @ViewChild("mafocus", { static: false }) mafocus: ElementRef;
  bnguonkinhphi: boolean = false;
  currentUser: any;
  phanheid: string;
  loaiphieu: number;
  loadDataInit(idchungtu: any, donviid: string, phanheid: string) {
    this.QuyetDinhPheDuyetNhaThau_Ngay = null;
    this.HopDong_Ngay = null;
    this.BienBanNghiemThu_Ngay = null;
    this.phanheid = phanheid;
    var authlogin = localStorage.getItem('currentUser');
    if (authlogin) {

      let data = JSON.parse(authlogin);
      this.currentUser = data;
      var giatri = data.ds_quyen.filter(name => name.id === idchungtu.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        this.modalTitle = giatri[0].ten_Phan_He;
        if (giatri[0].them == true)
          this.quyen_them = true;
        else
          this.quyen_them = false;
        if (giatri[0].sua == true)
          this.quyen_sua = true;
        else
          this.quyen_sua = false;
        if (giatri[0].xoa == true)
          this.quyen_xoa = true;
        else
          this.quyen_xoa = false;
      }
    }

    setTimeout(() => {
      this.mafocus.nativeElement.focus();
    }, 500);
   
    this.doituongSelect = {
      Id: null, SoCKCHDK: null, SoCKCHDTH: null, PhatHanhSec: null, ThongTinBoSung: null
      , NoTK1: null, CoTK1: null, NoTK2: null, CoTK2: null, NoTK3: null, CoTK3: null
      , MaDBHC: null, DonViId: null, NoiDungThanhToan: null
      , Tich_PhatHanhSec: null, Tich_ThongTinBoSung: null, SoToKhai: null
      , TenDonVi: null, MaSoThue: null, MaNDKT: null, MaChuong: null
      , CoQuanQuanLyThu:null,MaCQThu:null,KyThue:null,KBNNHachToanKhoanThu:null
      , ThanhToans: []
      , NoTK4: null, CoTK4: null, NoTK5: null, CoTK5: null, NoTK6: null, CoTK6: null
      , MaDBHC2: null, MaCQThu2: null, Tich_HienChiTietCacButToan: null
      , KBNNHachToanKhoanThu_Ma: null
    };
    
    this.doituongSelect.Id = idchungtu;
    this.doituongSelect.Tich_PhatHanhSec = false;
    this.doituongSelect.PhatHanhSec = 'Yêu cầu phát hành sec cho';
    this.doituongSelect.Tich_ThongTinBoSung = false;
    this.doituongSelect.Tich_HienChiTietCacButToan = true;
    this.doituongSelect.DonViId = donviid;

    this.repo.getRequest('api/donvicauhinh/thietlapthamso/' + donviid)
      .subscribe(response => {
        this.doituongSelect.TenDonVi = response.RDT16A2_TenDonVi;
        this.doituongSelect.MaSoThue = response.RDT16A2_MST;
        this.doituongSelect.MaNDKT = response.RDT16A2_NDKT;
        this.doituongSelect.MaChuong = response.RDT16A2_Chuong;
        this.doituongSelect.CoQuanQuanLyThu = response.RDT16A2_CoQuanQuanLyThu;
        this.doituongSelect.MaCQThu = response.RDT16A2_MaCQThu;
        this.doituongSelect.KyThue = response.RDT16A2_KyThue;
        this.doituongSelect.KBNNHachToanKhoanThu = response.RDT16A2_KBNN_HachToan;
        this.doituongSelect.KBNNHachToanKhoanThu_Ma = response.RDT16A2_KBNN_HachToan_Ma;




        this.doituongSelect1.Id = idchungtu;
        this.doituongSelect1.DonViId = donviid;
        this.doituongSelect1.LoaiMau = -1;
        if (phanheid == "94820ECA-77E5-42F1-A7C7-F15254E6A557") // mau 18 ND 347
        {
          this.doituongSelect1.LoaiMau = 118;
          this.loaiphieu = this.doituongSelect1.LoaiMau;
        }
        this.repo.postRequest("api/dvcapi/getbyid_dvc_thamso", this.doituongSelect1)
          .subscribe(response => {
            if (response != null && response.ThamSo != null && response.ThamSo != "") {
              let data = JSON.parse(response.ThamSo);
              //this.doituongSelect = data;

              this.doituongSelect.Id = data.Id;
              this.doituongSelect.SoCKCHDK = data.SoCKCHDK;
              this.doituongSelect.SoCKCHDTH = data.SoCKCHDTH;
              this.doituongSelect.PhatHanhSec = data.PhatHanhSec;
              this.doituongSelect.ThongTinBoSung = data.ThongTinBoSung;
              this.doituongSelect.NoTK1 = data.NoTK1;
              this.doituongSelect.CoTK1 = data.CoTK1;
              this.doituongSelect.NoTK2 = data.NoTK2;
              this.doituongSelect.CoTK2 = data.CoTK2;
              this.doituongSelect.NoTK3 = data.NoTK3;
              this.doituongSelect.CoTK3 = data.CoTK3;
              this.doituongSelect.MaDBHC = data.MaDBHC;
              this.doituongSelect.DonViId = data.DonViId;
              this.doituongSelect.NoiDungThanhToan = data.NoiDungThanhToan;
              this.doituongSelect.Tich_PhatHanhSec = data.Tich_PhatHanhSec;
              this.doituongSelect.Tich_ThongTinBoSung = data.Tich_ThongTinBoSung;
              this.doituongSelect.SoToKhai = data.SoToKhai;
              this.doituongSelect.TenDonVi = data.TenDonVi;
              this.doituongSelect.MaSoThue = data.MaSoThue;
              this.doituongSelect.MaNDKT = data.MaNDKT;
              this.doituongSelect.MaChuong = data.MaChuong;
              this.doituongSelect.CoQuanQuanLyThu = data.CoQuanQuanLyThu;
              this.doituongSelect.MaCQThu = data.MaCQThu;
              this.doituongSelect.KyThue = data.KyThue;
              this.doituongSelect.KBNNHachToanKhoanThu = data.KBNNHachToanKhoanThu;
              //this.doituongSelect.ThanhToans = data.ThanhToans;
              this.doituongSelect.NoTK4 = data.NoTK4;
              this.doituongSelect.CoTK4 = data.CoTK4;
              this.doituongSelect.NoTK5 = data.NoTK5;
              this.doituongSelect.CoTK5 = data.CoTK5;
              this.doituongSelect.NoTK6 = data.NoTK6;
              this.doituongSelect.CoTK6 = data.CoTK6;
              this.doituongSelect.MaDBHC2 = data.MaDBHC2;
              this.doituongSelect.MaCQThu2 = data.MaCQThu2;
              this.doituongSelect.Tich_HienChiTietCacButToan = data.Tich_HienChiTietCacButToan;
              this.doituongSelect.KBNNHachToanKhoanThu_Ma = data.KBNNHachToanKhoanThu_Ma;
                   

              this.doituongSelect.QuyetDinhPheDuyetNhaThau_So = data.QuyetDinhPheDuyetNhaThau_So;
              if (response.QuyetDinhPheDuyetNhaThau_Ngay != null)
                this.QuyetDinhPheDuyetNhaThau_Ngay = new Date(response.QuyetDinhPheDuyetNhaThau_Ngay);
              this.doituongSelect.HopDong_So = data.HopDong_So;
              if (response.HopDong_Ngay != null)
                this.HopDong_Ngay = new Date(response.HopDong_Ngay);
              this.doituongSelect.HopDong_TongSoTien = data.HopDong_TongSoTien;
              this.doituongSelect.QuyDinhVeMucTamUng = data.QuyDinhVeMucTamUng;
              this.doituongSelect.BienBanNghiemThu_So = data.BienBanNghiemThu_So;
              if (response.BienBanNghiemThu_Ngay != null)
                this.BienBanNghiemThu_Ngay = new Date(response.BienBanNghiemThu_Ngay);
              this.doituongSelect.BienBanNghiemThu_TongSoTien = data.BienBanNghiemThu_TongSoTien;
              this.doituongSelect.MaNhaTaiTro = data.MaNhaTaiTro;

             

            }

            this.doituongSelect1.v_ma_ho_so = response.v_ma_ho_so;
            this.doituongSelect1.v_tieu_de = response.v_tieu_de;

            this.repo.getRequest("api/doituong/thongtinuynhiemchi_mau18/" + idchungtu)
              .subscribe(response => {
                if (response != null && response != "") {
                  this.doituongSelect.ThanhToans = response;
                  // console.log(this.doituongSelect.ThanhToans);
                }
              });

          });



      });


  }

  keyTenPress(event: any) {
    if (event.which === 13) {
      this.slCapTren.focus();
      event.preventDefault();
    }
  }
  public closeModal() {
    this.save.emit(null);
  }
  //public saveproduct() {

  //  this.repo.postRequest("api/doituong/addorupdate", this.doituongSelect)
  //    .subscribe(response => {
  //      console.log(response);
  //      this.doituongSelect.Id = response;
  //      this.save.emit(this.doituongSelect);
  //    });

  //}
  public ngxCurrencyOptions = {
    prefix: '',
    thousands: '.',
    decimal: ',',
    precision: 0,
    allowNegative: false
  };
  itemrow: any;
  public changerange(row: any) {
    if (this.doituongSelect.ThanhToans != null) {
      for (let i: number = 0; i < this.doituongSelect.ThanhToans.length; i = i + 1) {
        this.itemrow = this.doituongSelect.ThanhToans[i];
        if (this.itemrow.IDCHUNGTU == row.IDCHUNGTU && row.NOPTHUE != null && this.itemrow.SOTIENDK!=null) {
            this.doituongSelect.ThanhToans[i].DONVIHUONG = this.doituongSelect.ThanhToans[i].SOTIENDK - this.doituongSelect.ThanhToans[i].NOPTHUE;
        }
      }
    }
  }
  public tuychinhmaubaocao() {
    this.dtsuamaubaocao.loadDataInit(this.phanheid);
    this.modaltuychinhmaubc.open();
  }
  public export(kieuin) {

    if (this.QuyetDinhPheDuyetNhaThau_Ngay != null)
      this.doituongSelect.QuyetDinhPheDuyetNhaThau_Ngay = this.QuyetDinhPheDuyetNhaThau_Ngay.getDate()
        + '/' + (this.QuyetDinhPheDuyetNhaThau_Ngay.getMonth() + 1)
        + '/' + this.QuyetDinhPheDuyetNhaThau_Ngay.getFullYear();
    else
      this.doituongSelect.QuyetDinhPheDuyetNhaThau_Ngay = null;

    if (this.HopDong_Ngay != null)
      this.doituongSelect.HopDong_Ngay = this.HopDong_Ngay.getDate()
        + '/' + (this.HopDong_Ngay.getMonth() + 1)
        + '/' + this.HopDong_Ngay.getFullYear();
    else
      this.doituongSelect.HopDong_Ngay = null;

    if (this.BienBanNghiemThu_Ngay != null)
      this.doituongSelect.BienBanNghiemThu_Ngay = this.BienBanNghiemThu_Ngay.getDate()
        + '/' + (this.BienBanNghiemThu_Ngay.getMonth() + 1)
        + '/' + this.BienBanNghiemThu_Ngay.getFullYear();
    else
      this.doituongSelect.BienBanNghiemThu_Ngay = null;


    this.doituongSelect1.DoiTuong = JSON.stringify(this.doituongSelect);

    this.repo.postRequest("api/dvcapi/addorupdate_thamso", this.doituongSelect1)
      .subscribe(response => {
        // lưu tham số
      });

    $('#loading').show();

    let data = {
      Id: this.phanheid, // id cứng trong FunctionConstants để điều hướng đến hàm thuc thi báo cáo
      Type: kieuin,
      Data: JSON.stringify(this.doituongSelect)
    };
    if (kieuin === 'xlsx') {
      this.repo.postPdf(Global.BASE_BaoCao_SAVE, data)
        .subscribe(response => {
          $('#loading').hide();
          var file = new Blob([response.body], { type: 'vnd.ms-excel' });
          var fileURL = URL.createObjectURL(file);
          var a = document.createElement("a");
          a.href = fileURL;
          a.download = "uynhiemchi-c4_02c.xlsx";
          document.body.appendChild(a);
          a.click();

        });
    }
    if (kieuin === 'pdf') {
      this.repo.postPdf(Global.BASE_BaoCao_SAVE, data)
        .subscribe(response => {
          //console.log("tt");
          //console.log(response);
          if (response == "L") {
            $('#loading').hide();
            //this.repo.postRequest(Global.BASE_BaoCao_SAVE, data).subscribe(
            //  data => {
            //    $('#loading').hide();
            //  },
            //  error => {
            //    this.msg = error;
            //  }
            //);
          }
          else {
            $('#loading').hide();
            var file = new Blob([response.body], { type: 'application/pdf' });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL, "EPrescription");
          }

        });
    }
    


  }


  export_xml() {
    //loaiphieu=1 giấy rút mẫu 02
    //loaiphieu=2 giấy rút mẫu 02b
    //loaiphieu=3 Bảng kê chứng từ thanh toán tạm ứng
    //loaiphieu=4 giấy đề nghị thanh toán tạm ứng

    if (this.QuyetDinhPheDuyetNhaThau_Ngay != null)
      this.doituongSelect.QuyetDinhPheDuyetNhaThau_Ngay = this.QuyetDinhPheDuyetNhaThau_Ngay.getDate()
        + '/' + (this.QuyetDinhPheDuyetNhaThau_Ngay.getMonth() + 1)
        + '/' + this.QuyetDinhPheDuyetNhaThau_Ngay.getFullYear();
    else
      this.doituongSelect.QuyetDinhPheDuyetNhaThau_Ngay = null;

    if (this.HopDong_Ngay != null)
      this.doituongSelect.HopDong_Ngay = this.HopDong_Ngay.getDate()
        + '/' + (this.HopDong_Ngay.getMonth() + 1)
        + '/' + this.HopDong_Ngay.getFullYear();
    else
      this.doituongSelect.HopDong_Ngay = null;

    if (this.BienBanNghiemThu_Ngay != null)
      this.doituongSelect.BienBanNghiemThu_Ngay = this.BienBanNghiemThu_Ngay.getDate()
        + '/' + (this.BienBanNghiemThu_Ngay.getMonth() + 1)
        + '/' + this.BienBanNghiemThu_Ngay.getFullYear();
    else
      this.doituongSelect.BienBanNghiemThu_Ngay = null;


    this.doituongSelect1.DoiTuong = JSON.stringify(this.doituongSelect);

    $('#loading').show();
    let datatt = {
      Id: null,
      Type: null,
      Data: JSON.stringify({
        DonViId: this.currentUser.id_don_vi
        , UserName: this.currentUser.user_name
        , IdChungTu: this.doituongSelect.Id
        , LoaiPhieu: this.loaiphieu 
        , Id:this.doituongSelect.Id
        , Tich_HienChiTietCacButToan: this.doituongSelect.Tich_HienChiTietCacButToan
        , PhatHanhSec: this.doituongSelect.PhatHanhSec, ThongTinBoSung: this.doituongSelect.ThongTinBoSung
        , NoTK1: this.doituongSelect.NoTK1, CoTK1: this.doituongSelect.CoTK1, NoTK2: this.doituongSelect.NoTK2
        , CoTK2: this.doituongSelect.CoTK2, NoTK3: this.doituongSelect.NoTK3, CoTK3: this.doituongSelect.CoTK3
        , MaDBHC: this.doituongSelect.MaDBHC, NoiDungThanhToan: this.doituongSelect.NoiDungThanhToan
        , Tich_PhatHanhSec: this.doituongSelect.Tich_PhatHanhSec, Tich_ThongTinBoSung: this.doituongSelect.Tich_ThongTinBoSung
        , SoToKhai: this.doituongSelect.SoToKhai
        , TenDonVi: this.doituongSelect.TenDonVi, MaSoThue: this.doituongSelect.MaSoThue, MaNDKT: this.doituongSelect.MaNDKT
        , MaChuong: this.doituongSelect.MaChuong
        , CoQuanQuanLyThu: this.doituongSelect.CoQuanQuanLyThu, MaCQThu: this.doituongSelect.MaCQThu, KyThue: this.doituongSelect.KyThue
        , KBNNHachToanKhoanThu: this.doituongSelect.KBNNHachToanKhoanThu
        , ThanhToans: this.doituongSelect.ThanhToans 
        , NoTK4: this.doituongSelect.NoTK4, CoTK4: this.doituongSelect.CoTK4, NoTK5: this.doituongSelect.NoTK5
        , CoTK5: this.doituongSelect.CoTK5, NoTK6: this.doituongSelect.NoTK6, CoTK6: this.doituongSelect.CoTK6
        , MaDBHC2: this.doituongSelect.MaDBHC2, MaCQThu2: this.doituongSelect.MaCQThu2
        , DoiTuong: this.doituongSelect1.DoiTuong
      })
    };


    this.repo.postRequest("api/baocao/ketnoikbnn_uynhiemchic402/", datatt)
      .subscribe(response => {
        $('#loading').hide();
        if (response.TrangThai = "OK") {
          location.href = "/Logs/Reports/" + response.DuongDan;
        }
        else
          swal('Cảnh báo!', response.TrangThai, 'warning');
      });



  }
  savedvc(doituong: any) {
    //this.modal_dvckbnn.dismiss();
  }
  kysodvc() {
    //if (this.selectedRows == null || this.selectedRows == "") {
    //  swal('Cảnh báo!', 'Chưa chọn chứng từ để in!.', 'warning');
    //  return;
    //}
    //let idchungtu = "";
    //this.selectedRows.forEach((item: any) => {
    //  idchungtu = item.Id;
    //  if (idchungtu != null)
    //    return true;
    //});
    //this.dtthamdvckbnnedit.loadDataInit(this.doituongSelect, this.currentUser.id_don_vi, 4);
    //this.modal_dvckbnn.open();
  }




}
